// Impact load figures for the team page (SPO-1534).
//
// Impact load is the sum of the peak g of an athlete's impacts in a session.
// Sessions without impact data are left out: they say nothing about load, and
// counting them as 0 pulled the average down.

const round = (value) => Math.round(value * 10) / 10;

/**
 * Team: points from the team load chart, each { totalLoad, athletes }.
 * Player: points from the athlete's chart, each { playerLoad, played }.
 *
 * Returns { avg, total, sessions }:
 * - avg: impact load per athlete per session (null without data)
 * - total: the sum of impact load over the period
 * - sessions: how many sessions had data
 */
export const impactLoadStats = (points = [], { player = false } = {}) => {
  if (player) {
    const played = points.filter((p) => p.played);
    const total = played.reduce((sum, p) => sum + (p.playerLoad || 0), 0);
    return {
      avg: played.length ? round(total / played.length) : null,
      total: round(total),
      sessions: played.length,
    };
  }

  const withData = points.filter((p) => p.athletes > 0 && p.totalLoad != null);
  const total = withData.reduce((sum, p) => sum + p.totalLoad, 0);
  const athleteSessions = withData.reduce((sum, p) => sum + p.athletes, 0);
  return {
    avg: athleteSessions ? round(total / athleteSessions) : null,
    total: round(total),
    sessions: withData.length,
  };
};

// One team load-chart point from the API. Older APIs have no total_load or
// athletes: fall back to the average as a single athlete's load.
export const teamLoadPoint = (d) => {
  const hasData = d.avg_load != null;
  return {
    totalLoad: d.total_load ?? (hasData ? d.avg_load : null),
    athletes: d.athletes ?? (hasData ? 1 : 0),
  };
};
